import { useContext } from "react";
import { ModalContext } from "../context/ModalContext";

export const useTabModal = () => {
    const context = useContext(ModalContext);

    if (!context) {
        throw new Error("useTabs must be used within a <Modal />");
    }

    return context;
};
